import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import { ButtonWrapper, ButtonLink, ButtonComponent } from 'bdata-sns-shared/utils/getProductButtons';

const {
    linkBlue
} = COLORS;

const getHoverBorderColor = ({ theme }) => (theme.hoverBorderColor || 'transparent');
// Adds custom styles to the buttons inside so the icon will appear
// on top, the divs will flex according to width, and there will
// be bars between the buttons
export const ActionLayerWrapper = styled.div`
    && {
        background-color: #eee;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
    }    
    ${ButtonWrapper} {
      flex: 1;
      position: relative;
      &:not(:last-child) {
          border-bottom: 1px solid ${getHoverBorderColor};
      }
      ${ButtonLink} {
        height: 100%;
        display: flex;
        flex-direction: row;
        color: #000;
        background-color: inherit;
        ${ButtonComponent} {
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 0px;
            color: inherit;          
            svg {
                display: block;
                margin: auto;
                margin-bottom: 4px;
            }
            &:focus {
                outline: none;
                box-shadow: inset rgb(0 137 255 / 65%) 0px 0px 0px 3px;
            }
            &:hover, &:focus {
                span {
                    color: ${linkBlue};
                }
                svg {
                  path {
                      fill: ${linkBlue};
                  }
                  rect {
                    fill: ${linkBlue};
                    stroke: ${linkBlue};
                  }
                  fill: ${linkBlue};
                  stroke: ${linkBlue};
                }
            }
        }
        span  {
          width: 100%;
          display: block;
          margin: 0;
          font-weight: bold;
          margin-left: 0px;
        }
      }
    }
`;
